/**
 * This simple type specifies how to cap the ends of lines.
 * This also affects the ends of line segments for dashed lines.
 *
 * REF: ECMA-376, Third Edition, Part 1 | Section: 20.1.10.31
 * Deviating from microsoft predefined approach here, defining our own line caps
 */

export enum LineCap  {
    NO_ARROW = "NO_ARROW",
    STEALTH_ARROW = "STEALTH_ARROW",
    LINE_ARROW = "LINE_ARROW",
    TRIANGLE_ARROW= "TRIANGLE_ARROW",
};
